module.exports = __webpack_public_path__ + "assets/img/result-bg.ec193075.png";